import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Redirect, useLocation } from "react-router-dom";
import { useState } from "react";
import { loginToBackend } from "../services/backend-api";
import { captureMessage } from "@sentry/minimal";
import { useAuthContext } from "@src/AuthContext";
import { GoogleLogin, GoogleLoginProps } from "@react-oauth/google";

const useStyles = makeStyles({
  centeredText: { textAlign: "center" },
  errorMessage: {
    textAlign: "center",
    color: "red",
  },
  button: {
    display: "flex",
    justifyContent: "center",
    paddingTop: 20,
  },
  buttonText: { fontWeight: 750 },
});

export function LoginPage() {
  const [errorMessage, setErrorMessage] = useState(null as null | string);
  const classes = useStyles();
  const location = useLocation<{ PREVIOUS_PATH?: string } | null>();
  const authInfo = useAuthContext();

  const onSuccess: GoogleLoginProps["onSuccess"] = (credentialResponse) => {
    const googleUser = {
      tokenObj: { id_token: credentialResponse.credential },
    };
    loginToBackend(googleUser, location.state?.PREVIOUS_PATH).catch((err) => {
      setErrorMessage(err.message);
    });
  };

  const onError: GoogleLoginProps["onError"] = (...errorArgs) => {
    console.error("login failed", { errorArgs });
    errorArgs?.forEach((a) => console.error(a));
    console.error(errorArgs);
    setErrorMessage(
      "An unknown error occured. **We're currently investigating issues with Google Sign In. We apologize for any inconvenience!"
    );
    captureMessage("UNKNOWN_GIS_ERROR", {
      extra: {
        url: window.location.href,
        errorArgs,
        stringifiedErrorArgs: JSON.stringify(errorArgs),
      },
    });
  };

  if (authInfo && authInfo.authed) {
    return <Redirect to={{ pathname: "/" }} />;
  }

  if (authInfo) {
    return (
      <div className={classes.centeredText}>
        <h3>Welcome!</h3>
        <span>Please login with Google to continue.</span>
        <br />
        <span>This is required to verify that you're in the group.</span>

        <div className={classes.button}>
          <GoogleLogin
            // useOneTap TODO: test one-tap on chrome browser with only one ggl acc logged in
            // ^ https://developers.google.com/identity/gsi/web/guides/automatic-sign-in-sign-out#sign-out
            onSuccess={onSuccess}
            onError={onError}
            cancel_on_tap_outside={false}
            // theme={"filled_black"}
            // text="continue_with"
            // shape="pill"
          />
        </div>

        {errorMessage && (
          <div style={{ paddingTop: 5 }}>
            <span className={classes.errorMessage}>{errorMessage}</span>
            {errorMessage.includes("contact") && (
              <div>
                <a style={{ color: "white" }} href="mailto:liara.evie@gmail.com">
                  e-mail
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  return <div style={{ display: "flex", justifyContent: "center" }}>Loading...</div>;
}

export class LoginRedirectedPage extends React.Component {
  state = {
    error: "",
  };
  componentDidMount() {
    const id_token = window.location.hash
      .split("&")
      .find((s) => s.startsWith("id_token"))
      ?.split("=")[1];
    if (!id_token) this.setState({ error: "Unable to retrieve token." });
    else {
      loginToBackend({
        tokenObj: { id_token },
      }).catch((err) => {
        // alert(`Error signing in: ${err.message}`);
        this.setState({ error: err.message });
      });
    }
  }
  render() {
    return this.state.error ? (
      <div style={{ display: "flex", justifyContent: "center" }}>{this.state.error}</div>
    ) : (
      <div style={{ display: "flex", justifyContent: "center" }}>Loading...</div>
    );
  }
}
